export {
    ElInput,
    ElInputNumber,
    ElSelect,
    ElOption,
    ElSelectV2,
    ElTreeSelect,
    ElCascader,
    ElDatePicker,
    ElTimePicker,
    ElTimeSelect,
    ElSwitch,
    ElSlider
} from "element-plus";
